module.exports = require("../lib/hooks/useLocalStorage");